<template>
    <div class="grid-x">
        <div v-if="enabled" class="cell"><p><strong>Product Search</strong> Search by code or name - 2 character minimum</p></div>
        <div v-if="enabled" class="cell">
            <div class="search-input-container">
            <input ref="search" class="search-input" type="text" v-model="searchinput" @keyup="getItemList()">
            
            <div class="search-input-list" v-if="searchresults">
                <p v-for="(item, index) in searchresults" @click="choose(item)">
                    {{ item.value }}
                </p>
            </div>
            </div>
        </div>
        <div v-show="itemdetail" class="cell">
            <div class="grid-x grid-padding-y">
                <div class="cell">
                    <div class="grid-x grid-padding-x">
                        <div class="small-4 medium-3 large-3 cell"><img :src="itemdetail.img" /></div>
                        <div class="small-12 medium-9 large-9 cell">
                            <p><strong>Code:</strong> {{ itemdetail.Code }}</p>
                            <p><strong>Name:</strong> {{ itemdetail.Name }}</p>
                            <p><strong>{{ itemdetail.Title }}</strong></p>
                        </div>
                    </div>
                </div>
                <div v-if="itemdetail.Code"  class="cell">
                    <div  v-if="enabled" class="grid-x grid-padding-x">
                        <div class="small-6 cell text-right">
                            <p>
                            <button class="button search" @click.prevent="newSearch()" style="width:100%; margin-bottom: 0;">Search Again</button>
                            </p>
                        </div>
                        <div class="small-6 cell auto text-right">
                            <p>
                            <button class="button add" @click.prevent="addItem($event)" style="width:100%">Confirm</button>
                            </p>
                        </div>                        
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, inject, watch, nextTick } from 'vue'
    import siteUrl from '@/helpers/site-url'
    import RendiliCore from '@RendiliCore'

    const searchinput = ref('')
    const searchresults = ref([])
    const chosenproduct = ref('')
    const itemdetail = ref('')
    const timer = ref(null)

    const props = defineProps([ 'clear', 'enabled', 'value' ])
    const emit = defineEmits([ 'chosen' ])

    defineOptions({
        name: 'CarpetLookup'
    })


    function getItemList() {
        if(searchinput.value.length < 2) {
            return;
        }
        if(timer.value == null) {
            timer.value = setTimeout(function() {
                searchItems();
            }, 200);
        }
    }

    function clearTimeout() {
        if (timer.value != null) {
            timer.value = null;
        }
    }

    function searchItems() {
        RendiliCore.Json.Get(siteUrl('alternative/warranty/search_carpet/') + searchinput.value)
        .then(function (response) {
            searchresults.value = response.items;
            clearTimeout();
        });
    }
    
    function choose(item) {
        clearTimeout();
        chosenproduct.value = item.code;
        searchinput.value = item.value;
        searchresults.value = [];
        getDetail();
    }
    
    function getDetail() {
        RendiliCore.Json.Get(siteUrl('alternative/warranty/carpet_detail/') + chosenproduct.value)
        .then(function (response) {
            itemdetail.value = response.data;
            $('.add').focus();
        });            
    }

    function addItem(event) {
        event.preventDefault();
        searchresults.value = [];
        searchinput.value = '';
        clearTimeout();
        emit('chosen', chosenproduct.value );
    }
    
    function newSearch(event) {
        searchresults.value = [];
        searchinput.value = '';
        chosenproduct.value = '';
        itemdetail.value = '';
        //this.$nextTick(() => this.$refs.search.focus());
    }

  
  watch(() => props.value, async (newValue, oldValue) => {
    if(newValue == null){
        newSearch();
    }
  }, { immediate: true })

</script>